import { NgModule} from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { SmartadminLayoutModule } from "./layout";

import {I18nModule} from "./i18n/i18n.module";
import {UtilsModule} from "./utils/utils.module";
import { BootstrapModule } from "@app/shared/bootstrap.module";
import {PipesModule} from "./pipes/pipes.module";
import { ReactiveFormsModule } from '@angular/forms';
 import {SmartadminWidgetsModule} from "./widgets/smartadmin-widgets.module";
import { FormlyModule } from "@ngx-formly/core";
import { NgFormlyConfig } from "./dynamic-form/formly";
import { FormlyBootstrapModule } from "@ngx-formly/bootstrap";
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { OwlcalenderComponent } from '@app/shared/ui/owlcalender/owlcalender.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,

    SmartadminLayoutModule,
    BootstrapModule,
    ReactiveFormsModule,
    SmartadminWidgetsModule,
    FormlyModule.forRoot(NgFormlyConfig),
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    
  ],
  declarations: [
    OwlcalenderComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    // UserModule,
    SmartadminLayoutModule,
    BootstrapModule,

    I18nModule,

    UtilsModule,
    PipesModule,

    // SmartadminFormsLiteModule,

    // SmartProgressbarModule,

    // InlineGraphsModule,

     SmartadminWidgetsModule,

    // ChatModule,

    // StatsModule,

    // VoiceControlModule,

    // CalendarComponentsModule,
    FormlyModule,
    FormlyBootstrapModule,
    OwlcalenderComponent,
    OwlDateTimeModule,
    OwlNativeDateTimeModule
  ]
})
export class SharedModule {}
